import React, { useCallback, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin, message } from "antd";
import requests from "../../axios/requests";
import { useFetch } from "../../../utils/hooks/useFetch";
import { HeaderNew } from "./Components/Header/HeaderNew";
import ModalInvite from "./Components/ModalInvite/ModalInvite";
import { CourseLanding } from "./CourseLanding/CourseLanding";
import Error404 from "../../components/Error404";

const landingApi = {
  getSkillsMarket: (ids) => requests.quests.get_skills_market(ids),
  getReviews: (ses) => requests.quests.get_quest_reviews_public(ses),
  postQuestion: (obj) => requests.quests.post_user_question(obj),
};

export const LandingNew = () => {
  const params = useParams();
  const history = useNavigate();
  const quest_id = params?.id;
  const { user } = useSelector((state) => state.Reducer);
  const [openInvite, setOpenInvite] = useState(false);

  // Мемоизируем промис, чтобы он не пересоздавался при каждом рендере
  const coursePromise = useMemo(
    () => requests.quests.get_course_id("/" + quest_id),
    [quest_id]
  );
  const { data, error, loading } = useFetch(coursePromise);

  // Логика оплаты/записи - как в PayButton
  const handleBuy = useCallback(() => {
    if (!user?.fio) return history("/student/auth", { state: params.id });
    if (data?.participateprice > 0) {
      requests.quests
        .payment_init_post({ ses: data.ses })
        .then((res) => {
          if (res.data.payment_url) window.open(res.data.payment_url, "_blank");
        })
        .catch((err) => {
          console.error(err);
          message.error(err?.response?.data?.error || "Не удалось перейти к оплате");
        });
      return;
    }
    requests.quests
      .add_request_quest({ quest_id: data?.id, userName: user.fio })
      .then((res) => {
        if (res.status === 201) message.success("успешно записан");
        if (res.status === 203) message.warning("вы уже записаны на данный курс");
        history(`/student/course/lesson/${data.id}`);
      })
      .catch((err) => console.error(err));
  }, [data, user, history, params.id]);

  if (loading) return <Spin />;
  if (error) return <Error404 />;

  return (
    <>
      <HeaderNew data={data} />
      <CourseLanding
        data={data}
        api={landingApi}
        onBuy={handleBuy}
        onShare={() => setOpenInvite(true)}
        onBack={() => history(-1)}
        viewerName={user?.fio}
      />
      <ModalInvite openModalInvite={openInvite} setOpenModalInvite={setOpenInvite} data={data} />
    </>
  );
};
